import { transformDateValue } from 'core/js/FormUtils';
export const getPhproductView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let phproductList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Party Name","fieldValue":transformDataValue(data.partyname,"bodynamiclist"), "fieldType":"bodynamiclist"},
                            {"fieldLabel":"Title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Status","fieldValue":transformDataValue(data.status,"bodynamiclist"), "fieldType":"bodynamiclist"},
              
              
            ],
            'dataList': [
                              {"fieldLabel":"Boxes Required","fieldValue":transformDataValue(data.boxesrequired,"number"), "fieldType":"number"},
                            {"fieldLabel":"Form","fieldValue":transformDataValue(data.form,"bodynamiclist"), "fieldType":"bodynamiclist"},
                            {"fieldLabel":"Packaging Material","fieldValue":transformDataValue(data.packagingmaterial,"bodynamiclist"), "fieldType":"bodynamiclist"},
              
              ]
          }

          phproductList.push(card);
  })
  return phproductList;
}